// Detect if userAgent represents Safari versions <= 11.1
export const isSafariWithoutFullWasmSupport = () => {
    const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
    const isSafari = /Safari/.test(ua) && !/Chrome|Chromium/.test(ua);
    if (isSafari) {
        const version = ua.match(/Version\/(\d+)\.(\d+)/);
        if (version) {
            const major = parseInt(version[1]);
            const minor = parseInt(version[2]);
            return major < 11 || (major === 11 && minor <= 1);
        }
    }
    return false;
};
